"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("./Dataset");
class NftDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.create = (this.sendRequest(interfaces_1.WEN_FUNC.createNft));
        this.createBatch = (this.sendRequest(interfaces_1.WEN_FUNC.createBatchNft));
        this.setForSale = (this.sendRequest(interfaces_1.WEN_FUNC.setForSaleNft));
        this.withdraw = (this.sendRequest(interfaces_1.WEN_FUNC.withdrawNft));
        this.deposit = (this.sendRequest(interfaces_1.WEN_FUNC.depositNft));
        this.updateUnsold = (this.sendRequest(interfaces_1.WEN_FUNC.updateUnsoldNft));
        this.order = (this.sendRequest(interfaces_1.WEN_FUNC.orderNft));
        this.openBid = (this.sendRequest(interfaces_1.WEN_FUNC.openBid));
        this.getByCollectionLive = (collection, orderBy, orderByDir, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['hidden', 'collection'],
                fieldValue: [false, collection],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy,
                orderByDir,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getByOwnerLive = (owner, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['hidden', 'owner'],
                fieldValue: [false, owner],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['updatedOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.NftDataset = NftDataset;
